import { UPDATE_CLIENT_TAGS_LIST } from './updateClientTagsList.types';

const updateClientTagsList = (data) => ({
  type: UPDATE_CLIENT_TAGS_LIST,
  data,
});

export default updateClientTagsList;
